import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import IPSALogo from '../../assets/images/oneprotect_icon.png'

import IpsaContext from '../../context/IpsaContext'

const Container = styled.div`
    margin-top: 3em;
`

const BackToPortal = () => {
    const { refreshUser } = useContext(IpsaContext)
    return (
        <Container>
            <ul className="button-list">
                <li>
                    <Link to="/dashboard" className="btn" onClick={() => refreshUser()}>
                        <img
                            id="back-icon"
                            src={IPSALogo}
                            alt="Back Icon"
                            height="35px"
                            style={{ margin: '-10px 0' }}
                        />{' '}
                        BACK TO PORTAL
                        <span></span>
                    </Link>
                </li>
            </ul>
        </Container>
    )
}

export default BackToPortal
